const scrollSnapStop = {
  name: "scroll-snap-stop",
  path: "scroll-snap-stop",
  title: "scroll-snap-stop",
  description: "Utilities for controlling whether you can skip past possible snap positions.",
  value: {
    "scroll-snap-stop": {
      "snap-normal": "normal",
      "snap-always": "always"
    }
  },
 exampleData: [
        {
            "title": "snap-always",
            "description": "utility together with the snap-mandatory utility to force a snap container to always stop on an element before the user can continue scrolling to the next item:",
            "moreDescription": "",
            "parentClass": "relative flex w-full snap-x-mandatory gap-6 overflow-x-auto py-10 !bg-none !border-0",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-40 shrink-0 rounded-lg opacity-0",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-80 shrink-0 rounded-lg",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-80 shrink-0 rounded-lg",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-80 shrink-0 rounded-lg",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-40 shrink-0 rounded-lg opacity-0",
                    },
                ],
                "className": "relative snap-center snap-always shrink-0",
                "code": `<div class="snap-x-mandatory ...">
  <div class="snap-center ...">
    <img src="/img/image-01.jpg" />
  </div>
  <div class="snap-center ...">
    <img src="/img/image-02.jpg" />
  </div>
  <div class="snap-center ...">
    <img src="/img/image-03.jpg" />
  </div>
  <div class="snap-center ...">
    <img src="/img/image-04.jpg" />
  </div>
  <div class="snap-center ...">
    <img src="/img/image-05.jpg" />
  </div>
  <div class="snap-center ...">
    <img src="/img/image-06.jpg" />
  </div>
</div>`
            }
        },
        {
            "title": "snap-start",
            "description": " utility to snap an element to its start when being scrolled inside a snap container:",
            "moreDescription": "",
            "parentClass": "relative flex w-full snap-x-mandatory gap-6 overflow-x-auto py-10 !bg-none !border-0",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-40 shrink-0 rounded-lg opacity-0",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-80 shrink-0 rounded-lg",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-80 shrink-0 rounded-lg",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-80 shrink-0 rounded-lg",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-40 shrink-0 rounded-lg opacity-0",
                    },
                ],
                "className": "relative snap-center snap-normal shrink-0",
                "code": `<div class="snap-x-mandatory  ...">
  <div class="snap-center ...">
    <img src="/img/image-01.jpg" />
  </div>
  <div class="snap-center ...">
    <img src="/img/image-02.jpg" />
  </div>
  <div class="snap-center ...">
    <img src="/img/image-03.jpg" />
  </div>
  <div class="snap-center ...">
    <img src="/img/image-04.jpg" />
  </div>
  <div class="snap-center ...">
    <img src="/img/image-05.jpg" />
  </div>
  <div class="snap-center ...">
    <img src="/img/image-06.jpg" />
  </div>
</div>`
            }
        }
    ]
};

export default scrollSnapStop;